import Constants from '../../constants';
import './index_mWeb.css';
import { useLink } from 'react-router-stack';
import { isSmartPhone } from '../../utilities/helper';

const MatchTabHomeMWeb = ({ gameTypes }: any) => {
  const navigate = useLink();
  const iconLoader = (type: any) => {
    switch (type) {
      case 'New Games':
        return <Constants.Svgs.NewMobile />;
      case 'Cards':
        return <Constants.Svgs.CardsMobile />;
      case 'Quiz':
        return <Constants.Svgs.QuizMobile />;
      case 'Arcade':
        return <Constants.Svgs.ArcadeMobile />;
      case 'Racing':
        return <Constants.Svgs.RacingMobile />;
      case 'Puzzles':
        return <Constants.Svgs.PuzzlesMobile />;
      case 'Sports':
        return <Constants.Svgs.SportsMobile />;
      case 'Strategy':
        return <Constants.Svgs.StrategyMobile />;
      default:
        return <Constants.Svgs.NewMobile />;
    }
  };
  const onCategoryClicked = (type: any) => {
    navigate.push(`/viewall/${type.replace(' ', '').toLowerCase()}`);
  };
  return (
    <div
      className={
        isSmartPhone ? 'home_tab_match_tab_container_mWeb' : 'home_tab_match_tab_container'
      }>
      {gameTypes.map((item: any, idx: any) => {
        if (item.key !== 'Recently Played') {
          return (
            <div
              onClick={() => onCategoryClicked(item.title)}
              key={idx}
              className="home_tab_match_tab_wrapper">
              <div className="home_tab_match_tab_backdrop"></div>
              <div className="home_tab_match_tab_innerWrapper">
                {iconLoader(item.title)}

                <div className="home_tab_match_tab_name">{item.title}</div>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default MatchTabHomeMWeb;
